export default "__VITE_ASSET__O7OSZizg__"